import styled, { createGlobalStyle } from "styled-components";
import { themeTransitionStyles } from "./themeTransitions";
import { PageContainer } from "../components/CartOrders/styled";

export const Container = styled.div<{ hasBottomBar?: boolean }>(({ hasBottomBar = true, theme }) => {
    return {
        minHeight: hasBottomBar ? "calc(100dvh - 82px)" : "100dvh",
        height: hasBottomBar ? "calc(100dvh - 82px)" : "100dvh",

        // Fallback: older browsers / iOS webviews
        "@supports not (height: 100dvh)": {
            minHeight: hasBottomBar ? "calc(100vh - 82px)" : "100vh",
            height: hasBottomBar ? "calc(100vh - 82px)" : "100vh",
        },

        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        background: theme.colors[theme.colorMode].canvas_Primary,
        position: "relative",

        "@supports (padding-top: var(--sat))": {
            paddingTop: "var(--sat)",
        },

        // for cart page since it don't have bottom bar
        ...(!hasBottomBar && {
            "@supports (padding-bottom: var(--sab))": {
                paddingBottom: "var(--sab)",
            },
        }),
    };
});

export const Main = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

export const SearchContainer = styled(PageContainer)(({ theme }) => ({
    display: "block",
    background: theme.colorMode === "light" ? "#FFFBF7" : theme.colors.dark.canvas_Primary,
}));

export const LandingMain = styled(Main)`
    position: relative;
`;

export const ShuttleAppName = styled.div({
    display: "none",
});

export const BillSummaryContainer = styled(Container)(({ theme }) => ({
    background: theme.colors[theme.colorMode].background_Secondary,
}));

export const RazorpaySafeAreaStyles = createGlobalStyle`
    .razorpay-container > iframe {
        @supports (padding-top: var(--sat)) {
            padding-top: var(--sat) !important;
        }

        @supports (padding-bottom: var(--sab)) {
            padding-bottom: var(--sab) !important;
        }
    }
`;

export const GlobalStyledDigitalMenu = createGlobalStyle`
    body {
        overflow: hidden;

        /* stylelint-disable-next-line plugin/no-unsupported-browser-features */
        touch-action: manipulation;
        position:fixed;
        width:100%;
        height:100%;
    }
    
    button:focus,
    button:hover,
    button:focus-visible,
    button:active {
        outline: none !important;
        box-shadow: none !important;
        -webkit-tap-highlight-color: transparent !important;
    }

    * {
        -webkit-tap-highlight-color: transparent !important;
    }

    /* TODO: Move this fix to DLS - iOS V2 Add Button Hover Fix */
    @media (hover: none) {
        .add-button-left-container:hover,
        .add-button-right-container:hover,
        .add-button-center-container:hover {
            background: transparent !important;
        }
    } 

    /* Theme transition animations - imported from themeTransitions.ts */
    ${themeTransitionStyles}

`;

export const PaymentPageContainer = styled.div`
    height: 100%;
    background: ${({ theme }) => theme.colors[theme.colorMode].canvas_Primary};
`;
